enum BeneficiaryType {
	Unknown = 0,
	Person = 1,
	Company = 2
}
export default BeneficiaryType
